var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9772 18.7675L19.5172 17.2275C19.7247 17.0227 19.9871 16.8825 20.2727 16.8239C20.5582 16.7653 20.8547 16.7909 21.126 16.8975L23.0029 17.6469C23.277 17.7582 23.5121 17.9482 23.6785 18.1928C23.8449 18.4375 23.9352 18.726 23.9379 19.0219V22.4594C23.9363 22.6607 23.894 22.8596 23.8135 23.0441C23.733 23.2286 23.616 23.3949 23.4696 23.533C23.3231 23.6711 23.1502 23.7781 22.9613 23.8476C22.7724 23.9172 22.5714 23.9477 22.3704 23.9375C9.21849 23.1194 6.56474 11.9819 6.06287 7.7194C6.03957 7.51008 6.06086 7.2982 6.12532 7.0977C6.18979 6.8972 6.29599 6.71262 6.43691 6.55611C6.57784 6.3996 6.75031 6.27469 6.94297 6.18962C7.13564 6.10455 7.34413 6.06124 7.55474 6.06253H10.8754C11.1717 6.06341 11.461 6.15291 11.706 6.31954C11.951 6.48616 12.1406 6.72228 12.2504 6.99753L12.9997 8.8744C13.1099 9.14464 13.138 9.44134 13.0806 9.72746C13.0231 10.0136 12.8826 10.2764 12.6766 10.4832L11.1366 12.0232C11.1366 12.0232 12.0235 18.025 17.9772 18.7675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.fd368ce02b3d01b372ae69c4dfbadbeb.svg";
export { ForwardRef as ReactComponent };